import React from 'react';
import { Spinner } from '../../../components/UI';
import {
    Button,
    Paper,
    Box,
    Typography,
    makeStyles,
    IconButton,
    Tooltip,
    TablePagination,
    Grid,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableBody,
    Divider,
    ListItemIcon,
} from '@material-ui/core';
import {
    CM_FILTER_CARDS,
    TL_FILTER_CARDS,
    TL_TABLE_COLUMNS,
} from '../helper.cm';
import Searchbar from '../../../components/Searchbar';
import FilterModal, {
    FilteredState,
} from '../../../components/Modals/FilterModal';
import { CM_TABLE_COLUMNS } from '../helper.cm';
import { CMTableCell, CMTableHeadCell } from '../utility.component.cm';
import useTeamLead from './useTeamLead';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import clsx from 'clsx';
import { TrackingEnabledIcon } from '../../../assets/svg';
import ViewAttendanceModal from '../../../components/Modals/ViewAttendenceModal';
import moment from 'moment';
interface SingleTeamLeadPageProps {
    [key: string]: any;
}
const SingleTeamLeadPage: React.FC = ({
    ...props
}: SingleTeamLeadPageProps) => {
    //store values
    const {
        isLoading,
        styles,
        activeFilterCard,
        prepareFilterCard,
        prepareFilterOptions,
        containerRef,
        searchTextValue,
        onFilterApplied,
        filterValues,
        pagination,
        handleChangePage,
        handleChangeRowsPerPage,
        onBackendSearch,
        onSearchTextChange,
        onRemoveAll,
        getColumnComponentValue,
        cm,
        handleActiveFilterCard,
        teamLeadDetails,
        chipClass,
        commonStyles,
        loginClass,
        permissions,
        handleRowClick,
        tlAttendanceModalOpen,
        handleAttendanceModalOpen,
        handleAttendanceModalClose,
    } = useTeamLead(props);
    console.log('teamLeadDetails', teamLeadDetails);
    return (
        <Spinner loading={isLoading}>
            <Paper
                style={{ padding: '1rem' }}
                className={styles.filterContainer}
                elevation={0}
            >
                <Grid
                    container
                    spacing={1}
                    direction="row"
                    alignItems={'center'}
                >
                    <Grid item xs={6}>
                        <Box
                            display={'flex'}
                            flexDirection={'row'}
                            alignItems={'center'}
                            justifyContent={'flex-start'}
                        >
                            <ListItemIcon
                                onClick={(e) =>
                                    props?.history.push(
                                        '/cluster-management',
                                        {},
                                    )
                                }
                                className={styles.backIcon}
                            >
                                <ArrowBackIcon
                                    style={{
                                        fontSize: '1.5rem',
                                    }}
                                />
                            </ListItemIcon>
                            <Box>
                                <Box
                                    display={'flex'}
                                    alignItems={'center'}
                                    justifyContent={'flex-start'}
                                >
                                    <Typography
                                        className={commonStyles.boldText}
                                    >
                                        {teamLeadDetails?.name}
                                    </Typography>
                                    {!!teamLeadDetails?.status && (
                                        <Box
                                            className={clsx([
                                                commonStyles.chip,
                                                chipClass,
                                            ])}
                                        >
                                            <Typography
                                                component={'span'}
                                                className={
                                                    commonStyles.chipText
                                                }
                                            >
                                                {teamLeadDetails?.status ?? ''}
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                                <Box
                                    display={'flex'}
                                    alignItems={'center'}
                                    flexDirection={'row'}
                                >
                                    <Typography
                                        className={clsx(
                                            styles.tableValue,
                                            loginClass,
                                        )}
                                    >
                                        <Typography
                                            className={clsx(
                                                styles.tableValue,
                                                loginClass,
                                            )}
                                            component={'span'}
                                        >
                                            {teamLeadDetails?.signInAt
                                                ? moment(
                                                      teamLeadDetails?.signInAt,
                                                  ).format('hh:mm A')
                                                : ''}
                                            {teamLeadDetails?.signInAt &&
                                            teamLeadDetails?.signOutAt
                                                ? `- ${moment(
                                                      teamLeadDetails?.signOutAt,
                                                  ).format('hh:mm A')}`
                                                : !!teamLeadDetails?.signInAt
                                                ? '- Live'
                                                : ''}
                                        </Typography>
                                        {teamLeadDetails?.contactNumber && (
                                            <Typography
                                                className={styles.tableSubValue}
                                                component={'span'}
                                            >
                                                {teamLeadDetails?.signInAt
                                                    ? ' | '
                                                    : ''}
                                                {`${teamLeadDetails?.contactNumber}`}
                                            </Typography>
                                        )}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            display={'flex'}
                            flexDirection={'row'}
                            alignItems={'center'}
                            justifyContent={'flex-end'}
                        >
                            {!!teamLeadDetails?.orgBrokerEntityId &&
                                !!teamLeadDetails?.userInfoBrokerEntityId && (
                                    <Button
                                        style={{
                                            marginRight: '1rem',
                                            fontSize: 14,
                                            fontWeight: 700,
                                        }}
                                        variant="outlined"
                                        color="primary"
                                        onClick={(e) => {
                                            props?.history.push(
                                                `/map-view/tl-detail/${
                                                    props?.match?.params?.id ??
                                                    teamLeadDetails?.userId
                                                }`,
                                                {
                                                    payload: {
                                                        id: props?.match?.params
                                                            ?.id,
                                                        ...teamLeadDetails,
                                                    },
                                                    backUrl: `/cluster-management/details/${
                                                        props?.match?.params
                                                            ?.id ??
                                                        teamLeadDetails?.userId
                                                    }`,
                                                    backPayload:
                                                        props?.location?.state,
                                                },
                                            );
                                        }}
                                        disabled={!permissions.create}
                                        disableElevation
                                    >
                                        Track
                                    </Button>
                                )}
                            <Button
                                style={{
                                    marginRight: '1rem',
                                    fontSize: 14,
                                    fontWeight: 700,
                                }}
                                variant="outlined"
                                color="primary"
                                onClick={(e) => {
                                    handleAttendanceModalOpen();
                                }}
                                disabled={!permissions.create}
                                disableElevation
                            >
                                View Attendance
                            </Button>
                            {/* <Button
                                variant="contained"
                                style={{ fontSize: 14 }}
                                color="primary"
                                onClick={(e) => {}}
                                //disabled={!permissions.update}
                                disableElevation
                            >
                                {'Edit Info'}
                            </Button> */}
                        </Box>

                        {teamLeadDetails?.trackEnabled && (
                            <Box
                                display={'flex'}
                                flexDirection={'row'}
                                alignItems={'center'}
                                justifyContent={'flex-end'}
                                mt={'8px'}
                            >
                                <div
                                    style={{
                                        marginRight: '.5rem',
                                        marginLeft: '.5rem',
                                    }}
                                >
                                    <TrackingEnabledIcon />
                                </div>
                                <Typography
                                    style={{
                                        fontFamily: 'Nunito',
                                        fontSize: '14px',
                                        fontWeight: 'bold',
                                        color: '#14112d',
                                    }}
                                    className="tracking-text"
                                    variant="body1"
                                    gutterBottom
                                >
                                    {`Tracking Enabled`}
                                </Typography>
                            </Box>
                        )}
                    </Grid>
                </Grid>
            </Paper>
            <Paper style={{ padding: '1rem', paddingBottom: 0 }} elevation={0}>
                <Grid container spacing={2}>
                    {TL_FILTER_CARDS.map((card: any, index: number) => {
                        return (
                            <Grid
                                key={index}
                                xs={card?.xs ? card?.xs : true}
                                item
                                style={
                                    {
                                        //maxWidth: 'fit-content',
                                    }
                                }
                            >
                                <Paper
                                    className={styles.filterBox}
                                    style={
                                        {
                                            cursor: 'default',
                                        }
                                        /*card?.filterValue?.type ===
                                            activeFilterCard?.type &&
                                        !activeFilterCard?.subType
                                            ? {
                                                  backgroundColor: '#D1D8FF',
                                              }
                                            : {}*/
                                    }
                                    onClick={() => {
                                        handleActiveFilterCard(
                                            card?.filterValue,
                                        );
                                    }}
                                >
                                    {prepareFilterCard(card)}
                                </Paper>
                            </Grid>
                        );
                    })}
                </Grid>
                <Box
                    display={'flex'}
                    flexDirection={'row'}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    mt={2}
                    mb={2}
                >
                    <Box
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'center'}
                        flex={1}
                    >
                        <Searchbar
                            placeHolderText="Search by Rider’s details"
                            style={{
                                width: 'calc(100vw - 77%)',
                            }}
                            dataSource={null}
                            backendSearchbar={true}
                            onBackendSearch={onBackendSearch}
                            value={searchTextValue}
                            keys={['name', 'hubName']}
                            onFilter={async (filteredData: any) => {}}
                            onChange={onSearchTextChange}
                        />

                        {/*<FilterModal
                            disabled={false}
                            filterOptions={prepareFilterOptions()}
                            filteredValues={filterValues}
                            onFilterApplied={onFilterApplied}
                            onClose={null}
                            onRemoveAll={onRemoveAll}
                        />
                        <FilteredState
                            filterOptions={prepareFilterOptions()}
                            filteredValues={filterValues}
                            onDelete={(filterKey: any) => {}}
                            count={null}
                            selectInfo={null}
                            selected={null}
                            maxShow={4}
                        />*/}
                    </Box>
                </Box>
                <Paper
                    ref={containerRef}
                    className={styles.container}
                    elevation={0}
                >
                    {cm?.fleets?.teamLeadFleetLineItemList?.length ? (
                        <>
                            <TableContainer
                                component={Box}
                                className={styles.tableTLContainer}
                            >
                                <Table
                                    stickyHeader
                                    aria-label="Team Leads table"
                                >
                                    <TableHead>
                                        <TableRow>
                                            {TL_TABLE_COLUMNS?.map(
                                                (column: any, index: any) => {
                                                    return (
                                                        <CMTableHeadCell
                                                            key={`column${index}`}
                                                        >
                                                            {column?.name}
                                                        </CMTableHeadCell>
                                                    );
                                                },
                                            )}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {cm?.fleets?.teamLeadFleetLineItemList?.map(
                                            (row: any, rowIndex?: number) => (
                                                <>
                                                    <TableRow
                                                        key={row.name}
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={(e: any) => {
                                                            handleRowClick(
                                                                e,
                                                                row,
                                                            );
                                                        }}
                                                    >
                                                        {TL_TABLE_COLUMNS?.map(
                                                            (
                                                                column: any,
                                                                index: any,
                                                            ) => {
                                                                return (
                                                                    <CMTableCell
                                                                        key={`row${index}`}
                                                                    >
                                                                        {getColumnComponentValue(
                                                                            row,
                                                                            column,
                                                                            null,
                                                                        )}
                                                                    </CMTableCell>
                                                                );
                                                            },
                                                        )}
                                                    </TableRow>
                                                    <Divider
                                                        style={{
                                                            margin: '4px 0',
                                                            backgroundColor:
                                                                '#fff',
                                                        }}
                                                    />
                                                </>
                                            ),
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </>
                    ) : (
                        <Box
                            display={'flex'}
                            flexDirection={'column'}
                            alignItems={'center'}
                            justifyContent={'center'}
                        >
                            <Typography
                                component={'p'}
                                style={{
                                    color: '#ED0000',
                                    fontWeight: 700,
                                }}
                            >
                                No data found. Please retry filters and try
                                again.
                            </Typography>
                            <Typography
                                component={'p'}
                                style={{
                                    color: '#4CAF50',
                                    fontWeight: 700,
                                }}
                            >
                                Add Team Lead
                            </Typography>
                        </Box>
                    )}
                    {!!cm?.fleets?.teamLeadFleetLineItemList?.length && (
                        <Box className={styles.paginationContainer}>
                            <TablePagination
                                rowsPerPageOptions={
                                    cm?.fleets?.totalFilteredCount > 25
                                        ? [25, 50, 75, 100]
                                        : []
                                }
                                component="div"
                                count={
                                    cm?.fleets?.totalFilteredCount ??
                                    cm?.fleets?.teamLeadFleetLineItemList
                                        ?.length
                                }
                                rowsPerPage={pagination?.pageSize}
                                page={pagination?.pageNo}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        </Box>
                    )}
                </Paper>
            </Paper>
            {tlAttendanceModalOpen && (
                <ViewAttendanceModal
                    open={tlAttendanceModalOpen}
                    tlInfo={{
                        ...teamLeadDetails,
                        id: props?.match?.params?.id ?? teamLeadDetails?.userId,
                    }}
                    onClose={() => {
                        handleAttendanceModalClose();
                    }}
                />
            )}
        </Spinner>
    );
};
export default SingleTeamLeadPage;
